import { createSelector } from 'reselect';
import { getProp, getStringProp } from '@mews/fp';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { ResolveRoute } from '@mews/routing';
import { openModal } from './common';

export const getCompanyDetailUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('id'),
    (resolveRoute, id) => resolveRoute(RouteName.CompanyDetail, { id })
);

export const openCompanyDetail =
    (id: string): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = getCompanyDetailUrl(getState(), { id, resolveRoute });
        return dispatch(openModal(url));
    };
